cc.ClippingRectangleNode = cc.Node.extend({

    ctor: function (clippingRegion) {
        cc.Node.prototype.ctor.call(this)
        this._clippingEnabled = true
        this._clippingRegion = clippingRegion
    },

    getClippingRegion() { return this._clippingRegion },

    setClippingRegion(clippingRegion) { this._clippingRegion = clippingRegion },

    isClippingEnabled() { return this._clippingEnabled },

    setClippingEnabled(enabled) { this._clippingEnabled = enabled },

    _createRenderCmd() {
        return new cc.ClippingRectangleNode.WebGLRenderCmd(this)
    }
})

cc.ClippingRectangleNode.create = function (clippingRegion) {
    return new cc.ClippingRectangleNode(clippingRegion)
}

cc.ClippingRectangleNode.WebGLRenderCmd = function (renderable) {
    cc.Node.WebGLRenderCmd.call(this, renderable)
    this._scissorOldState = false
    this._clippingOldRect = null
    this._clippingCurRect = null
    this._beforeVisitCmdScissor = new cc.CustomRenderCmd(this, this._onBeforeVisitScissor)
    this._afterVisitCmdScissor = new cc.CustomRenderCmd(this, this._onAfterVisitScissor)
}

let proto = cc.ClippingRectangleNode.WebGLRenderCmd.prototype = Object.create(cc.Node.WebGLRenderCmd.prototype)
proto.constructor = cc.ClippingRectangleNode.WebGLRenderCmd

proto._onBeforeVisitScissor = function () {
    let node = this._node
    if (node._clippingEnabled) {
        let pos = node.convertToWorldSpace(cc.p(node._clippingRegion.x, node._clippingRegion.y))
        let t = node.getNodeToWorldTransform()
        let clippingRect = this._clippingCurRect = cc.rect(pos.x, pos.y, node._clippingRegion.width * t.a, node._clippingRegion.height * t.d)

        this._scissorOldState = gl.isEnabled(gl.SCISSOR_TEST)
        if (this._scissorOldState) {
            this._clippingOldRect = cc.view.getScissorRect()
            if (!cc.rectEqualToRect(this._clippingOldRect, this._clippingCurRect)) {
                cc.view.setScissorInPoints(clippingRect.x, clippingRect.y, clippingRect.width, clippingRect.height)
            }
        } else {
            gl.enable(gl.SCISSOR_TEST)
            cc.view.setScissorInPoints(clippingRect.x, clippingRect.y, clippingRect.width, clippingRect.height)
        }
    }
}

proto._onAfterVisitScissor = function () {
    if (this._node._clippingEnabled) {
        if (this._scissorOldState) {
            if (!cc.rectEqualToRect(this._clippingOldRect, this._clippingCurRect)) {
                cc.view.setScissorInPoints(this._clippingOldRect.x, this._clippingOldRect.y, this._clippingOldRect.width, this._clippingOldRect.height);
            }
        } else {
            gl.disable(gl.SCISSOR_TEST);
        }
    }
}

proto.visit = function (parentCmd) {
    cc.renderer.pushRenderCommand(this._beforeVisitCmdScissor)
    cc.Node.WebGLRenderCmd.prototype.visit.call(this, parentCmd)
    cc.renderer.pushRenderCommand(this._afterVisitCmdScissor)
}
